/* eslint-disable */
// This file is automatically generated from the generate:settings command. Manual changes will be overwritten.
export interface Options {
    "use_quantity_rate": boolean;
    "promotion_display_products": boolean;
    "promotion_display_categories": boolean;
    "promotion_display_brands": boolean;
    "promotion_display_families": boolean;
    "promotion_display_tags": boolean;
    "product_single_text": string;
    "product_case_text": string;
    "sell_cases": boolean;
    "find_on_lookup": boolean;
    "register_default_payment_method": string | null;
    "round_to": number;
    "prevent_blur": boolean;
    "register_offline_invoice_suffix": string;
    "invoice_width": number;
    "register_current_invoice_number": number;
    "team_message": string;
    "discount_require_reason": boolean;
    "default_sale_keys": string | null;
    "outlet_default_sale_keys": string | null;
    "register_default_sale_keys": string | null;
    "user_default_sale_keys": string | null;
    "register_default_receipt_template": string | null;
    "allow_cashout_without_sale": boolean;
    "sign_in_type": "type" | "click";
    "sign_in_require_password": boolean;
    "register_login_after_sale": boolean;
    "view_receipt_timeout": number;
    "outlet_enable_gift_cards": boolean;
    "outlet_gift_card_expiry_amount": number;
    "outlet_gift_card_expiry_period": "days" | "weeks" | "months" | "years";
    "outlet_gift_card_expiry_change": boolean;
    "share_gift_cards": boolean;
    "share_held_sales": boolean;
    "display_details_on_customer_add": boolean;
    "register_customer_display_left": number;
    "register_customer_display_top": number;
    "register_never_open_cash_drawer": boolean;
    "use_average_cost": boolean;
    "has_weighable_products": boolean;
    "register_training_sales_mode_enabled": boolean;
    "sign_in_mask_username": boolean;
    "timezone": string;
    "register_current_invoice_max": number | null;
    "outlet_accounts_flow_key": string;
    "register_customer_display": string;
    "keep_select_product_on_screen": boolean;
    "display_select_product_paginated": boolean;
    "outlet_email_receipt_template": string | null;
    "register_default_price_set": string | null;
    "outlet_use_global_cost": boolean;
    "register_safe_drop_amount": number;
    "register_print_receipt_on_refund": boolean;
    "integrate_liquid_mix": boolean;
    "register_integrated_receipts": boolean;
    "cross_promotion_count": boolean;
    "weight_price_labels": boolean;
    "note_on_held_sale": boolean;
    "use_components_and_packages": boolean;
    "outlet_update_last_cost_from_transfer": boolean;
    "outlet_update_average_cost_from_transfer": boolean;
    "outlet_send_transfers_using_average_cost": boolean;
    "outlet_default_statement": string;
    "price_change_notifications": boolean;
    "outlet_outlet_email": string;
    "cost_calculation_method": "last" | "mixed" | "average";
    "statement_reply_email": string;
    "register_next_invoice_batch": number | null;
    "family_distribution": "match_price_points" | "evenly";
    "date_format": string;
    "time_format": string;
    "start_of_week": "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday" | "sunday";
    "profitability_display": "profit-percentage" | "markup";
    "register_consolidate_sale_lines": boolean;
    "future_price_time": number;
    "auto_logout_time": number;
    "auto_logout_during_sale": boolean;
    "register_open_display_on_open_register": boolean;
    "currency_code": string;
    "number_locale": string;
    "require_refund_reason": boolean;
    "use_barcode_templates": boolean;
    "show_order_prices_using_average_cost": boolean;
    "register_note_on_closure_discrepancy": boolean;
    "register_dark_mode": "light" | "dark" | "auto";
    "register_dedicated_promotion_worker": boolean;
    "sale_keys_position": "left" | "right" | "default";
    "outlet_sale_keys_position": "left" | "right" | "default";
    "register_sale_keys_position": "left" | "right" | "default";
    "user_sale_keys_position": "left" | "right" | "default";
    "enable_metcash_host_integration": boolean;
    "outlet_metcash_credentials.customer_id": string;
    "outlet_metcash_credentials.state_code": string;
    "outlet_metcash_credentials.pillar_id": string;
    "outlet_metcash_credentials.import_promotions": boolean;
    "outlet_metcash_credentials.b2b_account": string;
    "outlet_metcash_credentials.password": string;
    "outlet_metcash_credentials.import_buying_periods": boolean;
    "rounding_mode": "redistribute" | "round";
    "search_customers_memory_level": "full" | "english" | "strict" | "offload";
    "search_products_memory_level": "full" | "english" | "strict" | "offload";
    "ui_logging_level": "essential" | "normal" | "verbose";
    "register_customer_display_mode": "presentation" | "popup";
    "require_cash_drawer_reason": boolean;
    "search_save_location": "indexeddb" | "none";
    "outlet_discount_below_cost_behaviour": "ignore" | "warn" | "prevent";
    "predefined_discount_reasons": Array<string>;
    "user_override_dark_mode": "default" | "light" | "dark" | "auto";
    "outlet_default_order_reviewers": Array<string>;
    "outlet_review_before_sending_order": boolean;
    "outlet_review_before_receiving_order": boolean;
    "outlet_review_before_sending_return": boolean;
    "outlet_review_before_sending_transfer": boolean;
    "outlet_review_before_receiving_transfer": boolean;
    "outlet_review_before_sending_credit_note": boolean;
    "outlet_review_receiving_quantity_discrepancy": boolean;
    "outlet_review_receiving_total_discrepancy": boolean;
    "outlet_review_receiving_cost_discrepancy": boolean;
    "outlet_minimum_order_review_approvals": number;
    "predefined_cash_drawer_reasons": Array<string>;
    "predefined_cash_out_reasons": Array<string>;
    "predefined_cash_in_reasons": Array<string>;
    "set_prices_based_on": "cost_calculation_method" | "last_cost" | "highest_cost";
    "sign_in_password_first_login": boolean;
    "register_invoice_number_mode": "incremental" | "random_string" | "random_number";
    "new_user_default_reporting_all_access": boolean;
    "flag_force_product_redesign": boolean;
    "flag:use_css_tickets": boolean;
    "flag:view_host_file": boolean;
}

export const defaultOptions: Options = {
    "use_quantity_rate": false,
    "promotion_display_products": true,
    "promotion_display_categories": true,
    "promotion_display_brands": true,
    "promotion_display_families": true,
    "promotion_display_tags": true,
    "product_single_text": "Item",
    "product_case_text": "Case",
    "sell_cases": true,
    "find_on_lookup": false,
    "register_default_payment_method": null,
    "round_to": 0.05,
    "prevent_blur": true,
    "register_offline_invoice_suffix": "",
    "invoice_width": 0,
    "register_current_invoice_number": 1000,
    "team_message": "Need assistance? <a href=\"https://support.onshopfront.com\">Check out our help center</a>.",
    "discount_require_reason": false,
    "default_sale_keys": null,
    "outlet_default_sale_keys": "default",
    "register_default_sale_keys": "default",
    "user_default_sale_keys": "default",
    "register_default_receipt_template": null,
    "allow_cashout_without_sale": true,
    "sign_in_type": "click",
    "sign_in_require_password": true,
    "register_login_after_sale": false,
    "view_receipt_timeout": 10000,
    "outlet_enable_gift_cards": true,
    "outlet_gift_card_expiry_amount": 3,
    "outlet_gift_card_expiry_period": "years",
    "outlet_gift_card_expiry_change": true,
    "share_gift_cards": true,
    "share_held_sales": true,
    "display_details_on_customer_add": false,
    "register_customer_display_left": 0,
    "register_customer_display_top": 0,
    "register_never_open_cash_drawer": true,
    "use_average_cost": true,
    "has_weighable_products": false,
    "register_training_sales_mode_enabled": false,
    "sign_in_mask_username": false,
    "timezone": "Australia/Melbourne",
    "register_current_invoice_max": null,
    "outlet_accounts_flow_key": "",
    "register_customer_display": "",
    "keep_select_product_on_screen": false,
    "display_select_product_paginated": false,
    "outlet_email_receipt_template": null,
    "register_default_price_set": "default",
    "outlet_use_global_cost": true,
    "register_safe_drop_amount": Infinity,
    "register_print_receipt_on_refund": false,
    "integrate_liquid_mix": false,
    "register_integrated_receipts": true,
    "cross_promotion_count": true,
    "weight_price_labels": false,
    "note_on_held_sale": false,
    "use_components_and_packages": false,
    "outlet_update_last_cost_from_transfer": true,
    "outlet_update_average_cost_from_transfer": true,
    "outlet_send_transfers_using_average_cost": true,
    "outlet_default_statement": "",
    "price_change_notifications": false,
    "outlet_outlet_email": "noreply@onshopfront.com",
    "cost_calculation_method": "mixed",
    "statement_reply_email": "",
    "register_next_invoice_batch": null,
    "family_distribution": "match_price_points",
    "date_format": "DD/MM/YYYY",
    "time_format": "HH:mm:ss",
    "start_of_week": "monday",
    "profitability_display": "profit-percentage",
    "register_consolidate_sale_lines": true,
    "future_price_time": 0,
    "auto_logout_time": 0,
    "auto_logout_during_sale": false,
    "register_open_display_on_open_register": false,
    "currency_code": "AUD",
    "number_locale": "en-AU",
    "require_refund_reason": true,
    "use_barcode_templates": false,
    "show_order_prices_using_average_cost": false,
    "register_note_on_closure_discrepancy": false,
    "register_dark_mode": "light",
    "register_dedicated_promotion_worker": true,
    "sale_keys_position": "left",
    "outlet_sale_keys_position": "default",
    "register_sale_keys_position": "default",
    "user_sale_keys_position": "default",
    "enable_metcash_host_integration": false,
    "outlet_metcash_credentials.customer_id": "",
    "outlet_metcash_credentials.state_code": "",
    "outlet_metcash_credentials.pillar_id": "",
    "outlet_metcash_credentials.import_promotions": false,
    "outlet_metcash_credentials.b2b_account": "",
    "outlet_metcash_credentials.password": "",
    "outlet_metcash_credentials.import_buying_periods": false,
    "rounding_mode": "redistribute",
    "search_customers_memory_level": "full",
    "search_products_memory_level": "full",
    "ui_logging_level": "essential",
    "register_customer_display_mode": "popup",
    "require_cash_drawer_reason": false,
    "search_save_location": "indexeddb",
    "outlet_discount_below_cost_behaviour": "ignore",
    "predefined_discount_reasons": [],
    "user_override_dark_mode": "default",
    "outlet_default_order_reviewers": [],
    "outlet_review_before_sending_order": false,
    "outlet_review_before_receiving_order": false,
    "outlet_review_before_sending_return": false,
    "outlet_review_before_sending_transfer": false,
    "outlet_review_before_receiving_transfer": false,
    "outlet_review_before_sending_credit_note": false,
    "outlet_review_receiving_quantity_discrepancy": false,
    "outlet_review_receiving_total_discrepancy": false,
    "outlet_review_receiving_cost_discrepancy": false,
    "outlet_minimum_order_review_approvals": 0,
    "predefined_cash_drawer_reasons": [],
    "predefined_cash_out_reasons": [],
    "predefined_cash_in_reasons": [],
    "set_prices_based_on": "cost_calculation_method",
    "sign_in_password_first_login": false,
    "register_invoice_number_mode": "incremental",
    "new_user_default_reporting_all_access": true,
    "flag_force_product_redesign": true,
    "flag:use_css_tickets": false,
    "flag:view_host_file": false,
};